import { z } from "zod";

/**
 * The reversible curation ladder of a knowledge item (openspec
 * `add-knowledge-curation-states`). Archive is NOT a state: it stays the
 * existing `archived` marker.
 *
 * Kept apart from `knowledge-curation.ts` so the sources list, which only needs
 * the state to draw a badge, does not pull the whole review client into its chunk.
 */
export const curationStateSchema = z.enum(["active", "flagged", "suppressed"]);
export type CurationState = z.infer<typeof curationStateSchema>;

/** The text badge a source row shows for a state that is not the normal one.
 * `null` for an active item: it needs none. Never colour alone. */
export function curationBadgeLabel(state: CurationState): string | null {
  if (state === "suppressed") return "suprimido";
  if (state === "flagged") return "marcado";
  return null;
}
